__turbopack_context__.v({
  "btn": "not-found-module-scss-module__2jWFaq__btn",
  "code": "not-found-module-scss-module__2jWFaq__code",
  "desc": "not-found-module-scss-module__2jWFaq__desc",
  "title": "not-found-module-scss-module__2jWFaq__title",
  "wrap": "not-found-module-scss-module__2jWFaq__wrap",
});
